import React from 'react'

import * as S from './styles'

function Background (props) {
  let theme = {
    login_background_image: 'https://assetswp.sfo2.digitaloceanspaces.com/WL/dev/bg-login.jpg'
  }

  if (window.localStorage.getItem('whitelabel-theme')) {
    theme = JSON.parse(window.localStorage.getItem('whitelabel-theme'))
  }

  if (!theme) {
    return null
  }

  return <S.Background style={{ backgroundImage: `url(${theme.login_background_image})` }} />
}

export default Background
